import InteliIcon from "./InteliIcon"

export default InteliIcon
